export enum Permissions {
  Authenticate = 'authenticate',

  RetrieveOwnUsername = 'retrieve_own_username',
  RetrieveOwnPassword = 'retrieve_own_password',
  ChangeOwnPassword = 'change_own_password',

  ListStudentAccounts = 'list_student_accounts',
  ChangeStatusOfStudents = 'change_status_of_students',
  ChangeActivationKey = 'change_activation_key',
  ListSchoolStaffAccounts = 'list_school_staff_accounts',
  ListTempAccounts = 'list_temp_accounts',
  ListMireoAccounts = 'list_mireo_accounts',
  ListNonNormalizedAccounts = 'list_non_normalized_accounts',
  ListWaitingForSyncAccounts = 'list_waiting_for_sync_accounts',

  ModifyStudentWifi = 'modify_student_wifi',
  ResetStudentPassword = 'reset_student_password',
  ManageSchoolStaffAccounts = 'manage_school_staff_accounts',
  ManageMireoAccounts = 'manage_mireo_accounts',
  ManageTempAccounts = 'manage_temp_accounts',
  ManageExtras = 'manage_extras',
  ResetYearStudentsPassword = 'reset_year_students_password',

  SearchMultiSchool = 'search_multi_schools',

  ExportAccountsToCsv = 'export_accounts_to_csv',
  BulkImportTempAccounts = 'bulk_import_temp_accounts',

  DeleteGuestAccounts = 'delete_guest_accounts',
  SynchronizeAccount = 'synchronize_account',
  UpdateGuestAuthentication = 'update_guest_authentication',

  ListUserEvents = 'list_user_events',
  ListSchoolsEvents = 'list_schools_events',
  ListAllEvents = 'list_all_events',
  DeleteEvents = 'delete_events',

  ManagePermissions = 'manage_permissions',
  ManageRoles = 'manage_roles',
  ManageSchoolRoles = 'manage_school_roles',
  ManageServices = 'manage_services',

  ChangeOwnEmail = 'change_own_email',
  ChangeEmail = 'change_email',
  ChangeMireoEmail = 'change_email_mireo',

  AccessOpenAPI = 'access_open_api',
  AccessCipeoView = 'access_cipeo_view',

  ManageAdGroups = 'manage_ad_groups',
  ManageAdGroupsLinks = 'manage_ad_groups_links',

  GenerateLabels = 'generate_labels',

  ManageGuestUsers = 'manage_guest_users',
}

export default Permissions
